<!-- Test Scores - 考试分数 -->
<template>
  <div>
    <h1>Test Scores</h1>
    <ul class="ul-item dis-48 ">
      <li>
        <div>GRE Test Date</div>
        <div>{{info.greDate}}</div>
      </li>
      <li>
        <div>GRE Total</div>
        <div>{{info.greScore}}</div>
      </li>
    </ul>
    <ul class="ul-item dis-48 ">
      <li>
        <div>GRE Quant</div>
        <div>{{info.greQuant}}</div>
      </li>
      <li>
        <div>GRE Quant %</div>
        <div>{{info.greQuantPercentile}}</div>
      </li>
      <li>
        <div>GRE Verbal</div>
        <div>{{info.greVerbal}}</div>
      </li>
      <li>
        <div>GRE Verbal %</div>
        <div>{{info.greVerbalPercentile}}</div>
      </li>
      <li>
        <div>GRE Analytical Writing</div>
        <div>{{info.greWriting}}</div>
      </li>
      <li>
        <div>GRE Analytical Writing %</div>
        <div>{{info.greWritingPercentile}}</div>
      </li>
    </ul>
    <ul class="ul-item dis-96 ">
      <li>
        <div>GRE Sub</div>
        <div>{{info.greSub}}</div>
      </li>
    </ul>
    <ul class="ul-item dis-48 ">
      <li>
        <div>GMAT Test Date</div>
        <div>{{info.gmatDate}}</div>
      </li>
      <li>
        <div>GMAT Total</div>
        <div>{{info.gmatTotal}}</div>
      </li>
    </ul>
    <ul class="ul-item dis-96">
      <li>
        <div>GMAT Quant</div>
        <div>{{info.gmatQuant}}</div>
      </li>
      <li>
        <div>GMAT Quant %</div>
        <div>{{info.gmatQuantPercentile}}</div>
      </li>
      <li>
        <div>GMAT Verbal</div>
        <div>{{info.gmatVerbal}}</div>
      </li>
      <li>
        <div>GMAT Verbal %</div>
        <div>{{info.gmatVerbalPercentile}}</div>
      </li>
      <li>
        <div>GMAT Analytical Writing</div>
        <div>{{info.gmatAW}}</div>
      </li>
      <li>
        <div>GMAT Analytical Writing %</div>
        <div>{{info.gmatAWPercentile}}</div>
      </li>
      <li>
        <div>GMAT Intergrated Reasoning</div>
        <div>{{info.gmatIR}}</div>
      </li>
      <li>
        <div>GMAT Intergrated Reasoning % </div>
        <div>{{info.gmatIRPercentile}}</div>
      </li>
    </ul>
    <ul class="ul-item dis-48 ">
      <li>
        <div>TOEFL Test Date</div>
        <div>{{info.toeflDate}}</div>
      </li>
      <li>
        <div>Score</div>
        <div>{{info.toeflScore}}</div>
      </li>
    </ul>
    <ul class="ul-item dis-96">
      <li>
        <div>Reading</div>
        <div>{{info.toeflReading}}</div>
      </li>
      <li>
        <div>Listening</div>
        <div>{{info.toeflListening}}</div>
      </li>
      <li>
        <div>Speaking</div>
        <div>{{info.toeflSpeaking}}</div>
      </li>
      <li>
        <div>Writing</div>
        <div>{{info.toeflWriting}}</div>
      </li>
    </ul>
    <ul class="ul-item dis-48">
      <li>
        <div>IELTS Test Date</div>
        <div>{{info.ieltsDate}}</div>
      </li>
      <li>
        <div>Score</div>
        <div>{{info.ieltsScore}}</div>
      </li>
    </ul>
    <ul class="ul-item dis-96">
      <li>
        <div>Reading</div>
        <div>{{info.ieltsReading}}</div>
      </li>
      <li>
        <div>Listening</div>
        <div>{{info.ieltsListening}}</div>
      </li>
      <li>
        <div>Speaking</div>
        <div>{{info.ieltsSpeaking}}</div>
      </li>
      <li>
        <div>Writing</div>
        <div>{{info.ieltsWriting}}</div>
      </li>
    </ul>
    <ul class="ul-item">
      <li>
        <div>Plans to retake any test</div>
        <div>{{info.planToRetake}}</div>
      </li>
      <li>
        <div>Any other scores - LSAT</div>
        <div>{{info.otherScore1}}</div>
      </li>
      <li>
        <div>Any other scores - MCAT</div>
        <div>{{info.otherScore2}}</div>
      </li>
    </ul>
  </div>
</template>

<script>
// api
import { infoQueryScore } from '@/api/mentee'
export default {
  name: 'mentee-info-test',
  components: {},
  data () {
    return {
      info: {}
    }
  },
  computed: {},
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      let param = {
        num: this.$route.params.id
      }
      infoQueryScore(param).then(res => {
        let data = res.data.model || {}
        this.info = Object.assign({}, data)
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
